import * as React from 'react';

import { AIGenerateBrandedIcon, AIGenerateIcon } from '@coursera/cds-icons';

import CoachButton from 'bundles/ai-coach-platform/components/building-blocks/CoachButton';

import _t from 'i18n!nls/ai-coach-platform';

import type { Props as CoachButtonProps } from './CoachButton';

const ButtonIcon = ({ variant }: { variant: string }) =>
  variant === 'primary' ? <AIGenerateIcon color="invert" /> : <AIGenerateBrandedIcon />;

export type Props = { children: string; isBrandUpdateEnabled?: boolean } & CoachButtonProps;

/**
 * Simple wrapper around CoachButton to provide some specific styles.
 */
export const CoachTriggerButton = (props: Props): React.ReactElement => {
  const { variant = 'secondary', children, isBrandUpdateEnabled = false, ...rest } = props;

  return (
    <CoachButton
      variant={variant}
      size="small"
      aria-label={
        isBrandUpdateEnabled
          ? _t('#{label}, Coursera AI trigger', { label: children })
          : _t('#{label}, #{coachLabel} trigger', { label: children, coachLabel: 'Coach' })
      }
      icon={isBrandUpdateEnabled ? undefined : <ButtonIcon variant={variant} />}
      iconPosition="before"
      {...rest}
    >
      {children}
    </CoachButton>
  );
};

export default CoachTriggerButton;
